import { Position, Toaster } from '@blueprintjs/core'

const PrinterToaster = Toaster.create({
  className: 'printer-toaster',
  position: Position.TOP,
  maxToasts: 5
})

export default PrinterToaster
